import React, {Component} from 'react'
import CPageNew from '@/components/CPageNew'
import CBaseComponent from '@/components/CBaseComponent'
import { storeManageListNewData} from './data'
import './index.scss'
import { savebasedata} from "../../../../servers/commonApi";
import {bindActionCreators, compose} from "redux";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {message, Modal} from "antd";
import {
  refreshMenu,
} from "../../../../redux/common/action";
import {getJX, postJX} from "../../../../servers/menuAPI";
import store from "../../../../redux";
@CBaseComponent
class Legal extends Component{

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeEdit = this.onChangeEdit.bind(this);
    this.onChange = this.onChange.bind(this)
  }


  state = {
    data: storeManageListNewData,
    id:''
  }

  onChangeEdit(data){
    const result = this.state.data
    const d = result[0].data
    d.forEach(item=>{
        if (item.id === data.id){
          item.ifEdit = !item.ifEdit
          if (data.hasupload!== '') {
            d.forEach(item1=>{
              if (item1.id === data.hasupload){
                item1.ifEdit = !item1.ifEdit
              }
            })
          }
        }
      })
    this.setState({
      data:result
    })
  }

  onChange(value){
    const data = this.state.data
    data[0].data.forEach((item,index)=>{
      if (item.id === value.data.id) {
        item.value = value.value
      }
    })
    this.setState({
      data:data
    })
  }


  onSelect(){
    const params = {
      annual:localStorage.getItem('year'),
      museumid:store.getState().libraryid,
    }
    getJX(params).then(res=>{
      const r = JSON.parse(JSON.stringify(this.state.data))
      if (res.statecode === 0) {
        r[0].data.forEach(item=>{
          item.jpath = item.id
          item.value = res.records[0][item.id]
        })
        this.setState({
          data:r,
          id:res.records[0].id
        })
        console.log(this.state.data);
        console.log(this.state.id);
      }
    })
  }


  onSubmit(data){
    Modal.confirm({
      content: '确认提交数据',
      okText: '确认',
      cancelText: '取消',
      onCancel:()=>{
      },
      onOk:()=>{
        this.onSubmitHandler(data)
      }
    })
  }

  onSubmitHandler(data, type=''){
    if (data.status){
      data.data.id = this.state.id
      for (let key in data.data) {
        data.data[key] = data.data[key].toString()
      }
      postJX(data.data).then(res=>{
        if(res.statecode === 0) {
          this.props.refreshMenu(true)
          message.success('保存成功');
          // if (type === 'tz'){
          //   this.props.history.push({
          //     pathname: '/informationDeclaration/standardManage/organization/legal',
          //   });
          // }
        } else {
          message.error(res.statemessage);
        }
      })
    }
  }

   componentDidMount(){
    this.onSelect()
    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.onSelect()
        this.props.refreshMenu(true)
      }
    })
  }

  render(){
    return (
      <div className='store-manage-list-new' id='top'>
        <CPageNew
            data={this.state.data}
            onCancel={this.onCancel}
        />
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.year,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Legal);

